import { Flex, Heading, Tag, Text, Button } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

export interface IPlanCard {
  heading: string;
  price: number | string;
  isYearly: boolean;
  desc: string;
  isCurrentPlan: boolean;
  isBestChoice: boolean;
  onBtnClick: any;
  isSelected: boolean;
}

const PlanCard: React.FC<IPlanCard> = ({
  heading,
  price,
  isYearly,
  desc,
  isCurrentPlan,
  isBestChoice,
  onBtnClick,
  isSelected,
}) => {
  const { t } = useTranslation(['accountBilling']);

  const bestChoiceStyles = {
    borderColor: 'primary.500',
    bg: 'newBlue.100',
  };

  return (
    <Flex
      justifyContent="center"
      flexDirection="column"
      p={6}
      pb={16}
      border="1px solid"
      color="newGray.1000"
      borderRadius="lg"
      position="relative"
      textAlign="center"
      {...(isBestChoice ? bestChoiceStyles : { borderColor: 'gray.200' })}
    >
      <Heading as="h3" fontWeight="600" mb={1}>
        {heading}
      </Heading>
      <Flex alignItems="center" flexDirection="column" mb={8}>
        <Text fontSize="40" fontWeight="600">
          ${price}
          <Text as="span" fontSize="md" fontWeight="500" ml="0.5">
            {t('accountBilling:slashPerUser')}
          </Text>
        </Text>
        <Text color="gray.500" letterSpacing="0.01em">
          {isYearly ? t('accountBilling:billedAnnually') : t('accountBilling:billedMonthly')}
        </Text>
      </Flex>
      <Text fontSize="sm" fontWeight="600" mb={6}>
        {desc}
      </Text>
      <Button
        onClick={onBtnClick}
        colorScheme="secondary"
        isDisabled={isCurrentPlan}
        variant={isSelected ? 'outline' : 'solid'}
      >
        {isCurrentPlan ? `You are on ${heading}` : `Switch to ${heading}`}
      </Button>
      {isBestChoice ? (
        <Tag
          bg="primary.500"
          color="white"
          size="md"
          py={2}
          position="absolute"
          top="-15px"
          left="50%"
          transform="translateX(-50%)"
          fontSize="12px"
        >
          {t('accountBilling:popularChoice')}
        </Tag>
      ) : (
        ''
      )}
    </Flex>
  );
};

export default PlanCard;
